import React from "react";
import { connect } from "react-redux";
import { ContainerLeft, ContainerRight, Page } from "components/layouts";
import { media, Text } from "components/styled";
import { images } from "config/index";
import { aboutLocalization } from "localization";
import styled from "styled-components";
import { Box, Flex } from "grid-styled";
import { Link } from "react-router-dom";

const About = ({ selectedLanguage }) => {
  const {
    title,
    text1,
    text2,
    text3,
    text4,
    text5,
    text6,
    list1,
    list2,
    list3,
    list4
  } = aboutLocalization[selectedLanguage];

  function linkToOcds() {
    if (selectedLanguage === "en") {
      return (
        <span>
          The projects data maintained Open Contracting Data Standards (OCDS) to
          the extent they are available. Learn more about Open Contracting Data
          Standards{" "}
          <a
            href="http://standard.open-contracting.org/latest/en/"
            target="_blank"
            rel="noopener noreferrer"
          >
            here
          </a>
          .
        </span>
      );
    }
    return (
      <span>
        परियाेजनाका तथ्यांकलाई उपलब्ध भएका हदसम्म Open Contracting Data
        Standards (OCDS) का आधारमा व्यवस्थित गरिएकाे छ । Open Contracting Data
        Standards (OCDS) का बारेमा थप जान्नका लागि{" "}
        <a
          href="http://standard.open-contracting.org/latest/en/"
          target="_blank"
          rel="noopener noreferrer"
        >
          यहाँ जानुहाेस्
        </a>
        ।
      </span>
    );
  }

  return (
    <Page>
      <ContainerLeft>
        <AboutLinks>
          <Flex>
            <Box>
                <Link style={{
                    background: '#3b4155'
                }} to="/privacy-policy">Privacy Policy</Link>
            </Box>
            {/* <Box>
              <Link to="/how-to-use">How to use</Link>
            </Box> */}
          </Flex>
        </AboutLinks>
        <div className="main-title">{title}</div>
        <Content className="content" lang={selectedLanguage}>
          <div className="gov-logo">
            <img src={images.governmentLogo} alt="dashboard" />
            <div>
              <span>{text5}</span>
              <span>{text6}</span>
            </div>
          </div>
          <Text>{text1}</Text>
          <Text>{text2}</Text>
          <Text>{text3}</Text>
          <ul>
            <li>
              <span>{list1}</span>
            </li>
            <li>
              <span>{list2}</span>
            </li>
            <li>
              <span>{list3}</span>
            </li>
            <li>
              <span>{list4}</span>
            </li>
            <li>{linkToOcds()}</li>
          </ul>
          <Text className="text">{text4}</Text>
        </Content>
      </ContainerLeft>
      <ContainerRight>
        <div className="about-screenshot">
          <img src={images.about} alt="dashboard" />
        </div>
      </ContainerRight>
    </Page>
  );
};

const Content = styled.div`
  p,
  ol {
    font-size: ${props => (props.lang === "en" ? "16px" : "18px")};
  }
  img {
    @media all and (max-width: 500px) {
      max-width: 100%;
    }
  }

  .gov-logo {
    display: flex;
    margin-top: 40px;
    align-items: center;

    > img {
      margin-right: 18px;
    }

    > div {
      > span {
        display: block;

        &:first-child {
          font-size: 18px;
          font-weight: 600;
        }
        &:last-child {
          font-size: 16px;
        }
      }
    }
  }
`;

const AboutLinks = styled.div`
  margin: -10px 0 30px;
  ${media.tabletWide`
  margin: 0;
  position: absolute;
  right: 50px;
  top: 32px;
  `};
  a {
    border: 1px solid ${props => props.theme.primary.white};
    border-radius: 14px;
    color: ${props => props.theme.primary.white};
    display: block;
    font-size: 13px;
    line-height: 27px;
    margin-left: 16px;
    opacity: 0.7;
    text-align: center;
    text-decoration: none;
    width: 120px;
    &:hover {
      background-color: ${props => props.theme.dark.charcoalGrey};
      border-color: ${props => props.theme.dark.charcoalGrey};
      opacity: 1;
    }
  }
  div div:first-child > a {
    margin-left: 0;
  }
`;

export default connect(state => ({
  selectedLanguage: state.localizationReducers.selectedLanguage
}))(About);



// WEBPACK FOOTER //
// ./src/pages/about/about.js